<template>
  <div>
    <time-line class="left package-history-timeline" type="simple">
      <time-line-item v-for="item in packageHistory" :key="item.id" class="timeline-inverted"
                      :badgeType="convertOperationCodeColor(item.operation)"
                      :badgeIcon="convertOperationCodeIcon(item.operation)">
        <div slot="header" style="position: relative">
          <b-badge class="status-badge" :variant="convertOperationCodeColor(item.operation)">{{
            convertOperationCode(item.operation) }}
          </b-badge>
          <span class="ml-2 event-date-time">{{ convertDate(item.event_datetime) }}</span>
        </div>
        <p class="event" slot="content">{{ item.event }}</p>
      </time-line-item>
    </time-line>
  </div>
</template>
<script>
import moment from 'moment'
import TimeLine from './TimeLine/TimeLine'
import TimeLineItem from './TimeLine/TimeLineItem'
import { mapActions, mapMutations, mapState } from 'vuex'
import colors from './json/packageOperationCodesColors.json'

export default {
  components: {
    TimeLine,
    TimeLineItem
  },
  data () {
    return {}
  },
  mounted () {

  },
  computed: {
    ...mapState(
      {
        packageHistory: state => state.piportalApiSearch.packageHistory,
        operationCodes: state => state.piportalApiSearch.operationCodes
      }
    )
  },
  methods: {
    ...mapActions('packagesSearch', [
      'loadPackageHistory',
      'loadOperationCodes'
    ]),
    ...mapMutations([]),
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    convertDate (date) {
      return this.moment(date).format('DD.MM.YYYY HH:mm')
    },
    convertOperationCode (code) {
      return this.operationCodes.filter(operation => operation.code === code)[0].prefix
    },
    convertOperationCodeColor (code) {
      return colors.data.filter(color => color.code === code)[0].color
    },
    convertOperationCodeIcon (code) {
      return 'nc-icon ' + colors.data.filter(color => color.code === code)[0].icon
    }
  }
}
</script>
<style scoped>
  .package-history-timeline .card-timeline .timeline {
    padding: 0 !important;
  }

  .package-history-timeline .card-timeline .timeline > li {
    margin-bottom: 0px !important;
  }

  .package-history-timeline .card-timeline .timeline > li > div.timeline-panel {
    margin-bottom: 10px !important;
  }

  .event-date-time {
    position: absolute;
    right: 0px;
  }

  .card {
    background-color: #ECEFF1;
  }

  .status-badge {
    height: 24px;
    line-height: 16px;
    font-size: 14px;
  }
</style>
